<template>
  <edit-modal
    caption="Nieuwe Contentpagina"
    :isActive="isActive">
    <div class="field">
      <div class="control">
        <input class="input" type="text" placeholder="Naam" v-model="name">
      </div>
    </div>

    <div class="field">
      <div class="control">
        <label class="label">Publieke weergave</label>
        <label class="radio">
          <input type="radio" name="viewMode" v-model="viewMode" value="grid">
          Grid
        </label>

        <label class="radio">
          <input type="radio" name="viewMode" v-model="viewMode" value="tree">
          Boom
        </label>
      </div>
    </div>

    <save-buttons
      @save="save"
      @cancel="close">
    </save-buttons>
  </edit-modal>
</template>

<script>
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'tableId',
    'isActive'
  ],
  components: {
    EditModal,
    SaveButtons
  },
  data () {
    return {
      id: null,
      name: null,
      viewMode: 'grid'
    }
  },
  methods: {
    toggle (state) {
      this.isActive = state
    },
    save () {
      this.$store.dispatch('pages/save', {
        id: this.id,
        name: this.name,
        table_id: this.tableId,
        view_mode: this.viewMode
      })

      this.close()
    },
    close () {
      this.id = this.name = null
      this.$emit('close')
    }
  }
}
</script>
